var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-bold-dot-list-item',[_c('base-button',{attrs:{"is-link":"","href":_vm.getUrl}},[_vm._v(" "+_vm._s(_vm.value.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }